import ApiService from "@/services/Api"

import { Team } from "@/protocols/team"

export type TeamSearchQuery = {
	teamName: string
}

class TeamService {
	async getTeams (searchQuery?: TeamSearchQuery): Promise<Team[]> {
		const { data } = await ApiService.get("/team", {
			params: {
				team_name: searchQuery?.teamName
			}
		})

		return data.teams
	}
}

export default new TeamService()
